import React, {useCallback} from 'react';

import Radio from '@material-ui/core/Radio';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

interface Props extends Omit<React.ComponentProps<typeof MuiRadioGroup>, 'onChange'> {
  legend?: string;
  onChange: (newValue: string) => void;
  options: Array<{label: string; value: string | number}>;
}

export const RadioGroup: React.FC<Props> = ({legend, name, onChange, options, value}) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <FormControl component="fieldset">
      {legend && <FormLabel component="legend">{legend}</FormLabel>}
      <MuiRadioGroup row aria-label={name} name={name} value={value} onChange={handleChange}>
        {options.map(({label, value}) => (
          <FormControlLabel
            key={label}
            value={value}
            control={<Radio style={{paddingTop: 0, paddingBottom: 0}} />}
            label={label}
          />
        ))}
      </MuiRadioGroup>
    </FormControl>
  );
};
